import {range, zerofill} from "../utils/functions";

export const ImageKeyBlank = "blank";
export const DefaultCategoryName = "categoryE";

const make_picture_keys = function (name: string, count: number, ext: string) {
    return range(1, count).map(
        i => {
            const key = zerofill(i.toString(), 3);
            return {key: `${name}_${key}`, src: `/images/behavior/${name}/${key}.${ext}`};
            // cf: {key: 'picture-a_001',  src:'/images/behavior/picture-a/001.png'}
        }
    );
}

const all_image_key_src = [
    ...make_picture_keys('picture-a', 40, 'png'),
    ...make_picture_keys('picture-b', 40, 'png'),
    ...make_picture_keys('picture-c', 54, 'png'),
    ...make_picture_keys('picture-d', 238, 'jpg'),
    ...make_picture_keys('picture-e', 238, 'jpg'),
];

const ImageSrcMappings: Map<string, string> = new Map(
    [
        [ImageKeyBlank, "/images/behavior/blank.png"],
        ...all_image_key_src.map(p => [p.key, p.src]),
    ] as [string, string][]
);

const ImageCategories = [
    {
        category_name: DefaultCategoryName /* "categoryE" */,
        category_src: "/images/behavior/picture-e-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: '感情',
                image_keys: [
                    'picture-e_175',
                    'picture-e_119',
                    'picture-e_120',
                    'picture-e_121',
                    'picture-e_122',
                    'picture-e_123',
                    'picture-e_124',
                    'picture-e_125',
                    'picture-e_126',
                    'picture-e_176',
                    'picture-e_177',
                    'picture-e_178',
                    'picture-e_179',
                    'picture-e_180',
                ],
            },
            {
                tag: 'デスクワーク',
                image_keys: [
                    'picture-e_127',
                    'picture-e_128',
                    'picture-e_070',
                    'picture-e_010',
                    'picture-e_011',
                    'picture-e_066',
                    'picture-e_068',
                    'picture-e_181',
                    'picture-e_182',
                    'picture-e_183',
                    'picture-e_184',
                    'picture-e_157',

                ],
            },
            {
                tag: 'コミュニケーション',
                image_keys: [
                    'picture-e_018',
                    'picture-e_019',
                    'picture-e_020',
                    'picture-e_027',
                    'picture-e_044',
                    'picture-e_025',
                    'picture-e_026',
                    'picture-e_185',
                    'picture-e_186',
                    'picture-e_187',
                    'picture-e_188',
                    'picture-e_189',
                    'picture-e_190',
                    'picture-e_164',

                ],
            },
            {
                tag: '外出',
                image_keys: [
                    'picture-e_191',
                    'picture-e_192',
                    'picture-e_193',
                    'picture-e_194',
                    'picture-e_195',
                    'picture-e_196',
                    'picture-e_197',
                    'picture-e_198',
                    'picture-e_199',

                ],
            },
            {
                tag: '生活',
                image_keys: [
                    'picture-e_200',
                    'picture-e_114',
                    'picture-e_201',
                    'picture-e_140',
                    'picture-e_141',
                    'picture-e_142',
                    'picture-e_155',
                    'picture-e_156',
                    'picture-e_043',
                    'picture-e_112',
                    'picture-e_065',
                    'picture-e_091',
                    'picture-e_095',
                    'picture-e_050',
                    'picture-e_051',
                    'picture-e_055',
                    'picture-e_063',
                    'picture-e_064',
                    'picture-e_081',
                    'picture-e_082',
                    'picture-e_138',
                    'picture-e_056',
                    'picture-e_057',
                    'picture-e_058',
                    'picture-e_107',
                    'picture-e_109',
                    'picture-e_077',

                ],
            },
            {
                tag: 'スマホ・タブレット・PC',
                image_keys: [
                    'picture-e_001',
                    'picture-e_031',
                    'picture-e_029',
                    'picture-e_202',
                    'picture-e_076',
                    'picture-e_052',
                    'picture-e_168',
                    'picture-e_030',
                    'picture-e_099',
                    'picture-e_032',
                    'picture-e_042',
                    'picture-e_041',
                    'picture-e_080',
                    'picture-e_079',
                    'picture-e_053',
                    'picture-e_054',

                ],
            },
            {
                tag: 'お金・書類',
                image_keys: [
                    'picture-e_002',
                    'picture-e_203',
                    'picture-e_147',
                    'picture-e_117',
                    'picture-e_028',
                    'picture-e_062',
                    'picture-e_151',

                ],
            },
            {
                tag: '食べもの',
                image_keys: [
                    'picture-e_204',
                    'picture-e_205',
                    'picture-e_206',
                    'picture-e_207',
                    'picture-e_208',
                    'picture-e_209',
                    'picture-e_210',
                    'picture-e_211',
                    'picture-e_212',
                    'picture-e_213',

                ],
            },
            {
                tag: 'イベント',
                image_keys: [
                    'picture-e_100',
                    'picture-e_105',
                    'picture-e_102',
                    'picture-e_096',
                    'picture-e_214',
                    'picture-e_215',
                    'picture-e_216',
                    'picture-e_217',
                    'picture-e_218',
                    'picture-e_219',

                ],
            },
            {
                tag: '他',
                image_keys: [
                    'picture-e_103',
                    'picture-e_111',
                    'picture-e_024',
                    'picture-e_046',
                    'picture-e_048',
                    'picture-e_083',
                    'picture-e_085',
                    'picture-e_152',
                    'picture-e_006',
                    'picture-e_008',
                    'picture-e_009',
                    'picture-e_074',
                    'picture-e_098',
                    'picture-e_148',
                    'picture-e_033',
                    'picture-e_035',
                    'picture-e_037',
                    'picture-e_039',
                    'picture-e_072',
                    'picture-e_101',
                    'picture-e_116',
                    'picture-e_118',
                    'picture-e_144',
                    'picture-e_145',
                    'picture-e_150',
                ]
            },
        ],
    },
    {
        category_name: "categoryF",
        category_src: "/images/behavior/picture-f-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: '感情',
                image_keys: [
                    'picture-e_220',
                    'picture-e_129',
                    'picture-e_130',
                    'picture-e_131',
                    'picture-e_132',
                    'picture-e_133',
                    'picture-e_134',
                    'picture-e_135',
                    'picture-e_221',
                    'picture-e_222',
                    'picture-e_223',
                    'picture-e_224',
                    'picture-e_225',
                    'picture-e_153',

                ],
            },
            {
                tag: 'デスクワーク',
                image_keys: [
                    'picture-e_136',
                    'picture-e_137',
                    'picture-e_071',
                    'picture-e_012',
                    'picture-e_013',
                    'picture-e_067',
                    'picture-e_069',
                    'picture-e_226',
                    'picture-e_227',
                    'picture-e_228',
                    'picture-e_158',

                ],
            },
            {
                tag: 'コミュニケーション',
                image_keys: [
                    'picture-e_021',
                    'picture-e_022',
                    'picture-e_023',
                    'picture-e_027',
                    'picture-e_025',
                    'picture-e_026',
                    'picture-e_185',
                    'picture-e_229',
                    'picture-e_187',
                    'picture-e_230',
                    'picture-e_231',
                    'picture-e_232',
                    'picture-e_164',

                ],
            },
            {
                tag: '生活',
                image_keys: [
                    'picture-e_233',
                    'picture-e_115',
                    'picture-e_234',
                    'picture-e_235',
                    'picture-e_236',
                    'picture-e_237',
                    'picture-e_238',
                    'picture-e_005',
                    'picture-e_113',
                    'picture-e_065',
                    'picture-e_091',
                    'picture-e_050',
                    'picture-e_051',
                    'picture-e_055',
                    'picture-e_063',
                    'picture-e_064',
                    'picture-e_081',
                    'picture-e_082',
                    'picture-e_138',
                    'picture-e_059',
                    'picture-e_060',
                    'picture-e_061',
                    'picture-e_106',
                    'picture-e_108',
                    'picture-e_078',

                ],
            },
            {
                tag: 'スマホ・タブレット・PC',
                image_keys: [
                    'picture-e_001',
                    'picture-e_031',
                    'picture-e_029',
                    'picture-e_202',
                    'picture-e_076',
                    'picture-e_052',
                    'picture-e_168',
                    'picture-e_030',
                    'picture-e_099',
                    'picture-e_032',
                    'picture-e_042',
                    'picture-e_041',
                    'picture-e_080',
                    'picture-e_079',
                    'picture-e_053',
                    'picture-e_054',

                ],
            },
            {
                tag: 'お金・書類',
                image_keys: [
                    'picture-e_002',
                    'picture-e_203',
                    'picture-e_147',
                    'picture-e_117',
                    'picture-e_028',
                    'picture-e_062',
                    'picture-e_151',

                ],
            },
            {
                tag: '食べもの',
                image_keys: [
                    'picture-e_204',
                    'picture-e_205',
                    'picture-e_206',
                    'picture-e_207',
                    'picture-e_208',
                    'picture-e_209',
                    'picture-e_210',
                    'picture-e_211',
                    'picture-e_212',
                    'picture-e_213',

                ],
            },
            {
                tag: 'イベント',
                image_keys: [
                    'picture-e_100',
                    'picture-e_105',
                    'picture-e_102',
                    'picture-e_096',
                    'picture-e_214',
                    'picture-e_215',
                    'picture-e_216',
                    'picture-e_217',
                    'picture-e_218',
                    'picture-e_219',

                ],
            },
            {
                tag: '他',
                image_keys: [
                    'picture-e_104',
                    'picture-e_110',
                    'picture-e_024',
                    'picture-e_047',
                    'picture-e_049',
                    'picture-e_006',
                    'picture-e_008',
                    'picture-e_009',
                    'picture-e_074',
                    'picture-e_098',
                    'picture-e_148',
                    'picture-e_034',
                    'picture-e_036',
                    'picture-e_038',
                    'picture-e_040',
                    'picture-e_073',
                    'picture-e_101',
                    'picture-e_116',
                    'picture-e_118',
                    'picture-e_144',
                    'picture-e_145',
                    'picture-e_150',
                ]
            },
        ],
    },
    {
        category_name: "categoryG",
        category_src: "/images/behavior/picture-g-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: '感情',
                image_keys: [
                    'picture-d_175',
                    'picture-d_119',
                    'picture-d_120',
                    'picture-d_121',
                    'picture-d_122',
                    'picture-d_123',
                    'picture-d_124',
                    'picture-d_125',
                    'picture-d_126',
                    'picture-d_176',
                    'picture-d_177',
                    'picture-d_178',
                    'picture-d_179',
                    'picture-d_180',

                ],
            },
            {
                tag: 'デスクワーク',
                image_keys: [
                    'picture-d_127',
                    'picture-d_128',
                    'picture-d_070',
                    'picture-d_010',
                    'picture-d_011',
                    'picture-d_066',
                    'picture-d_068',
                    'picture-d_181',
                    'picture-d_182',
                    'picture-d_183',
                    'picture-d_184',
                    'picture-d_157',

                ],
            },
            {
                tag: 'コミュニケーション',
                image_keys: [
                    'picture-d_018',
                    'picture-d_019',
                    'picture-d_020',
                    'picture-d_027',
                    'picture-d_044',
                    'picture-d_025',
                    'picture-d_026',
                    'picture-d_185',
                    'picture-d_186',
                    'picture-d_187',
                    'picture-d_188',
                    'picture-d_189',
                    'picture-d_190',
                    'picture-d_164',

                ],
            },
            {
                tag: '外出',
                image_keys: [
                    'picture-d_191',
                    'picture-d_192',
                    'picture-d_193',
                    'picture-d_194',
                    'picture-d_195',
                    'picture-d_196',
                    'picture-d_197',
                    'picture-d_198',
                    'picture-d_199',

                ],
            },
            {
                tag: '生活',
                image_keys: [
                    'picture-d_200',
                    'picture-d_114',
                    'picture-d_201',
                    'picture-d_140',
                    'picture-d_141',
                    'picture-d_142',
                    'picture-d_155',
                    'picture-d_156',
                    'picture-d_043',
                    'picture-d_112',
                    'picture-d_065',
                    'picture-d_091',
                    'picture-d_095',
                    'picture-d_050',
                    'picture-d_051',
                    'picture-d_055',
                    'picture-d_063',
                    'picture-d_064',
                    'picture-d_081',
                    'picture-d_082',
                    'picture-d_138',
                    'picture-d_056',
                    'picture-d_057',
                    'picture-d_058',
                    'picture-d_107',
                    'picture-d_109',
                    'picture-d_077',

                ],
            },
            {
                tag: 'スマホ・タブレット・PC',
                image_keys: [
                    'picture-d_001',
                    'picture-d_031',
                    'picture-d_029',
                    'picture-d_202',
                    'picture-d_076',
                    'picture-d_052',
                    'picture-d_168',
                    'picture-d_030',
                    'picture-d_099',
                    'picture-d_032',
                    'picture-d_042',
                    'picture-d_041',
                    'picture-d_080',
                    'picture-d_079',
                    'picture-d_053',
                    'picture-d_054',

                ],
            },
            {
                tag: 'お金・書類',
                image_keys: [
                    'picture-d_002',
                    'picture-d_203',
                    'picture-d_147',
                    'picture-d_117',
                    'picture-d_028',
                    'picture-d_062',
                    'picture-d_151',

                ],
            },
            {
                tag: '食べもの',
                image_keys: [
                    'picture-d_204',
                    'picture-d_205',
                    'picture-d_206',
                    'picture-d_207',
                    'picture-d_208',
                    'picture-d_209',
                    'picture-d_210',
                    'picture-d_211',
                    'picture-d_212',
                    'picture-d_213',

                ],
            },
            {
                tag: 'イベント',
                image_keys: [
                    'picture-d_100',
                    'picture-d_105',
                    'picture-d_102',
                    'picture-d_096',
                    'picture-d_214',
                    'picture-d_215',
                    'picture-d_216',
                    'picture-d_217',
                    'picture-d_218',
                    'picture-d_219',

                ],
            },
            {
                tag: '他',
                image_keys: [
                    'picture-d_103',
                    'picture-d_111',
                    'picture-d_024',
                    'picture-d_046',
                    'picture-d_048',
                    'picture-d_083',
                    'picture-d_085',
                    'picture-d_152',
                    'picture-d_006',
                    'picture-d_008',
                    'picture-d_009',
                    'picture-d_074',
                    'picture-d_098',
                    'picture-d_148',
                    'picture-d_033',
                    'picture-d_035',
                    'picture-d_037',
                    'picture-d_039',
                    'picture-d_072',
                    'picture-d_101',
                    'picture-d_116',
                    'picture-d_118',
                    'picture-d_144',
                    'picture-d_145',
                    'picture-d_150',
                ]
            }
        ],
    },
    {
        category_name: "categoryD",
        category_src: "/images/behavior/picture-d-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: '感情',
                image_keys: [
                    'picture-d_220',
                    'picture-d_129',
                    'picture-d_130',
                    'picture-d_131',
                    'picture-d_132',
                    'picture-d_133',
                    'picture-d_134',
                    'picture-d_135',
                    'picture-d_221',
                    'picture-d_222',
                    'picture-d_223',
                    'picture-d_224',
                    'picture-d_225',
                    'picture-d_153',

                ],
            },
            {
                tag: 'デスクワーク',
                image_keys: [
                    'picture-d_136',
                    'picture-d_137',
                    'picture-d_071',
                    'picture-d_012',
                    'picture-d_013',
                    'picture-d_067',
                    'picture-d_069',
                    'picture-d_226',
                    'picture-d_227',
                    'picture-d_228',
                    'picture-d_158',

                ],
            },
            {
                tag: 'コミュニケーション',
                image_keys: [
                    'picture-d_021',
                    'picture-d_022',
                    'picture-d_023',
                    'picture-d_027',
                    'picture-d_025',
                    'picture-d_026',
                    'picture-d_185',
                    'picture-d_229',
                    'picture-d_187',
                    'picture-d_230',
                    'picture-d_231',
                    'picture-d_232',
                    'picture-d_164',

                ],
            },
            {
                tag: '生活',
                image_keys: [
                    'picture-d_233',
                    'picture-d_115',
                    'picture-d_234',
                    'picture-d_235',
                    'picture-d_236',
                    'picture-d_237',
                    'picture-d_238',
                    'picture-d_005',
                    'picture-d_113',
                    'picture-d_065',
                    'picture-d_091',
                    'picture-d_050',
                    'picture-d_051',
                    'picture-d_055',
                    'picture-d_063',
                    'picture-d_064',
                    'picture-d_081',
                    'picture-d_082',
                    'picture-d_138',
                    'picture-d_059',
                    'picture-d_060',
                    'picture-d_061',
                    'picture-d_106',
                    'picture-d_108',
                    'picture-d_078',

                ],
            },
            {
                tag: 'スマホ・タブレット・PC',
                image_keys: [
                    'picture-d_001',
                    'picture-d_031',
                    'picture-d_029',
                    'picture-d_202',
                    'picture-d_076',
                    'picture-d_052',
                    'picture-d_168',
                    'picture-d_030',
                    'picture-d_099',
                    'picture-d_032',
                    'picture-d_042',
                    'picture-d_041',
                    'picture-d_080',
                    'picture-d_079',
                    'picture-d_053',
                    'picture-d_054',

                ],
            },
            {
                tag: 'お金・書類',
                image_keys: [
                    'picture-d_002',
                    'picture-d_203',
                    'picture-d_147',
                    'picture-d_117',
                    'picture-d_028',
                    'picture-d_062',
                    'picture-d_151',

                ],
            },
            {
                tag: '食べもの',
                image_keys: [
                    'picture-d_204',
                    'picture-d_205',
                    'picture-d_206',
                    'picture-d_207',
                    'picture-d_208',
                    'picture-d_209',
                    'picture-d_210',
                    'picture-d_211',
                    'picture-d_212',
                    'picture-d_213',

                ],
            },
            {
                tag: 'イベント',
                image_keys: [
                    'picture-d_100',
                    'picture-d_105',
                    'picture-d_102',
                    'picture-d_096',
                    'picture-d_214',
                    'picture-d_215',
                    'picture-d_216',
                    'picture-d_217',
                    'picture-d_218',
                    'picture-d_219',

                ],
            },
            {
                tag: '他',
                image_keys: [
                    'picture-d_104',
                    'picture-d_110',
                    'picture-d_024',
                    'picture-d_047',
                    'picture-d_049',
                    'picture-d_006',
                    'picture-d_008',
                    'picture-d_009',
                    'picture-d_074',
                    'picture-d_098',
                    'picture-d_148',
                    'picture-d_034',
                    'picture-d_036',
                    'picture-d_038',
                    'picture-d_040',
                    'picture-d_073',
                    'picture-d_101',
                    'picture-d_116',
                    'picture-d_118',
                    'picture-d_144',
                    'picture-d_145',
                    'picture-d_150',
                ]
            }
        ]
    },
    {
        category_name: "categoryA",
        category_src: "/images/behavior/picture-a-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: 'ビジネス',
                image_keys: [

                    'picture-a_001',
                    'picture-a_003',
                    'picture-a_006',
                    'picture-a_007',
                    'picture-a_010',
                    'picture-a_014',
                    'picture-a_015',
                    'picture-a_016',
                    'picture-a_018',
                    'picture-a_020',
                    'picture-a_021',
                    'picture-a_022',
                    'picture-a_023',
                    'picture-a_024',
                    'picture-a_025',
                    'picture-a_039',

                ]
            },
            {
                tag: '生活',
                image_keys: [

                    'picture-a_002',
                    'picture-a_004',
                    'picture-a_012',
                    'picture-a_017',
                    'picture-a_026',
                    'picture-a_030',
                    'picture-a_035',
                    'picture-a_038',
                    'picture-a_036',
                    'picture-a_037',
                ]
            }
        ]
    },
    {
        category_name: "categoryH",
        category_src: "/images/behavior/picture-h-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: 'ビジネス',
                image_keys: [
                    'picture-a_005',
                    'picture-a_008',
                    'picture-a_010',
                    'picture-a_015',
                    'picture-a_016',
                    'picture-a_018',
                    'picture-a_019',
                    'picture-a_027',
                    'picture-a_028',
                    'picture-a_040',
                ]
            },
            {
                tag: '生活',
                image_keys: [
                    'picture-a_009',
                    'picture-a_011',
                    'picture-a_013',
                    'picture-a_026',
                    'picture-a_029',
                    'picture-a_031',
                    'picture-a_032',
                    'picture-a_033',
                    'picture-a_034',
                    'picture-a_035',
                    'picture-a_038',
                    'picture-a_036',
                ]
            }
        ],
    },
    {
        category_name: "categoryI",
        category_src: "/images/behavior/picture-i-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: 'ビジネス',
                image_keys: [

                    'picture-b_001',
                    'picture-b_003',
                    'picture-b_006',
                    'picture-b_007',
                    'picture-b_010',
                    'picture-b_014',
                    'picture-b_015',
                    'picture-b_016',
                    'picture-b_018',
                    'picture-b_020',
                    'picture-b_021',
                    'picture-b_022',
                    'picture-b_023',
                    'picture-b_024',
                    'picture-b_025',
                    'picture-b_039',

                ]
            },
            {
                tag: '生活',
                image_keys: [

                    'picture-b_002',
                    'picture-b_004',
                    'picture-b_012',
                    'picture-b_017',
                    'picture-b_026',
                    'picture-b_030',
                    'picture-b_035',
                    'picture-b_038',
                    'picture-b_036',
                    'picture-b_037',
                ]
            }
        ],
    },
    {
        category_name: "categoryB",
        category_src: "/images/behavior/picture-b-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: 'ビジネス',
                image_keys: [

                    'picture-b_005',
                    'picture-b_008',
                    'picture-b_010',
                    'picture-b_015',
                    'picture-b_016',
                    'picture-b_018',
                    'picture-b_019',
                    'picture-b_027',
                    'picture-b_028',
                    'picture-b_040',

                ]
            },
            {
                tag: '生活',
                image_keys: [

                    'picture-b_009',
                    'picture-b_011',
                    'picture-b_013',
                    'picture-b_026',
                    'picture-b_029',
                    'picture-b_031',
                    'picture-b_032',
                    'picture-b_033',
                    'picture-b_034',
                    'picture-b_035',
                    'picture-b_038',
                    'picture-b_036',
                ]
            },
        ]
    },
    {
        category_name: "categoryC",
        category_src: "/images/behavior/picture-c-thumbnail.jpg",
        image_keys_by_tag: [
            {
                tag: 'PC',
                image_keys: [

                    'picture-c_001',
                    'picture-c_002',
                    'picture-c_003',
                    'picture-c_004',
                    'picture-c_005',
                    'picture-c_006',
                    'picture-c_008',
                    'picture-c_009',
                    'picture-c_014',
                    'picture-c_015',
                    'picture-c_017',
                    'picture-c_018',
                    'picture-c_024',
                    'picture-c_034',
                    'picture-c_035',
                    'picture-c_043',
                    'picture-c_046',
                    'picture-c_048',
                    'picture-c_049',
                    'picture-c_050',
                    'picture-c_053',
                    'picture-c_054',

                ]
            },
            {
                tag: 'スマホ',
                image_keys: [

                    'picture-c_007',
                    'picture-c_012',
                    'picture-c_013',
                    'picture-c_022',
                    'picture-c_023',
                    'picture-c_027',
                    'picture-c_038',
                    'picture-c_051',

                ]
            },
            {
                tag: '他',
                image_keys: [

                    'picture-c_010',
                    'picture-c_011',
                    'picture-c_016',
                    'picture-c_019',
                    'picture-c_020',
                    'picture-c_021',
                    'picture-c_025',
                    'picture-c_026',
                    'picture-c_028',
                    'picture-c_029',
                    'picture-c_030',
                    'picture-c_031',
                    'picture-c_032',
                    'picture-c_033',
                    'picture-c_036',
                    'picture-c_037',
                    'picture-c_039',
                    'picture-c_040',
                    'picture-c_041',
                    'picture-c_042',
                    'picture-c_044',
                    'picture-c_045',
                    'picture-c_047',
                    'picture-c_052',
                ]
            }
        ]
    },
];

if (process.env.NODE_ENV === "development") {
    const all_tagged_keys = ImageCategories.map(c => c.image_keys_by_tag.map(i => i.image_keys).flat()).flat();
    const not_tagged_keys = all_image_key_src.map(m => m.key).filter(image_key => !all_tagged_keys.includes(image_key));
    if (0 < not_tagged_keys.length) {
        ImageCategories.push(
            {
                category_name: "未分類",
                category_src: "/images/behavior/blank.png",
                image_keys_by_tag: [
                    {
                        tag: '未分類',
                        image_keys: not_tagged_keys
                    }
                ]
            },
        );
        console.log(not_tagged_keys);
    }
}

export function BehaviorImageCategories() {
    return ImageCategories.map(c => 0 || {category_name: c.category_name, category_src: c.category_src});
}

export function BehaviorImageKeysWithTag(category_name: string) {
    const cat = ImageCategories.find(c => c.category_name === category_name)
    if (cat === undefined) {
        throw new Error(`invalid category_name: ${category_name}`);
    }

    return Array.from(cat.image_keys_by_tag);
}

export function ImageKey2Src(image_key: string) {
    if (ImageSrcMappings.has(image_key)) {
        return ImageSrcMappings.get(image_key);
    }

    return ImageSrcMappings.get(ImageKeyBlank);
}

export function BehaviorImageKey2CategoryName(image_key: string): string {
    if (image_key === ImageKeyBlank) {
        return DefaultCategoryName;
    }

    const c = ImageCategories.find(c =>
        c.image_keys_by_tag.find(t => t.image_keys.find(key => key === image_key) !== undefined) !== undefined
    );
    if (c === undefined) {
        // 見つからないということは無いはずだけど、念のため
        return DefaultCategoryName;
    }

    return c.category_name;
}
